import { Account, AccountClient, ApplicationUser } from "@src/apis/ModularClient";

export class AccountsController {
  user: ApplicationUser;
  performingAction: boolean;
  selectedAccount: Account;
  accounts: Account[];
  account: Account;
  photoUploadProgress: number;
  import1Message: string = null;
  import2Message: string = null;
  uploadingPhoto: boolean;

  static $inject = ["$scope", "$rootScope", "$cookies", "$location", "$http", "AccountClient"];

  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    private $http: ng.IHttpService,
    private $accountClient: AccountClient,
  ) {
    this.performingAction = false;

    this.selectedAccount = null;

    //get all the accounts back
    this.FetchAccounts();
  }
  selectAccount(account: Account) {
    this.selectedAccount = account;
  }

  createAccount(): void {
    this.selectedAccount = {
      accountName: "New Account",

      activebrandingAccount: false,
      createdDateTime: undefined,
      createdUser: undefined,
      createdUserId: 0,
      dashBoardItemBgColour: "",
      dashBoardItemFgColour: "",
      dashBoardStripeBgColour: "",
      emailAddressesOfAdmin: "",
      emailAddress: "",
      enableEmailTracking: false,
      id: 0,
      isDeleted: false,
      lastModifiedUser: undefined,
      lastModifiedUserId: 0,
      lastUpdatedDateTime: undefined,
      loginUserBgColour: "",
      loginUserFgColour: "",
      nameOrTelNumberTextFrom: "",
      password: "",
      port: 0,
      primaryEmailAccount: false,
      primarySMSAccount: false,
      runEmailAndTextsInTestMode: false,
      saveBarFgColour: "",
      senderNameInEmail: "",
      server: "",
      smsAccount: false,
      smsPassword: "",
      smsUser: "",
      testEmailAddresses: "",
      useHangfire: false,
      user: "",
      webSiteTabTitle: "",
      webTitle: "",
      webTitleImage: "",
    };
  }

  FetchAccounts(): void {
    this.performingAction = true;
    this.$accountClient
      .list()
      .then((response) => {
        this.accounts = response;
        this.performingAction = false;
      })
      .catch((response) => {
        this.performingAction = false;
      });
  }

  deleteAccount(): void {
    this.$accountClient.markAsDeleted(this.selectedAccount.id).then((result: boolean) => {
      this.accounts.splice(this.accounts.indexOf(this.selectedAccount), 1);
      //                this.$toaster.pop('success', "Deleted account!", "The account has been removed from the system.");
      delete this.selectedAccount;
    });
  }

  updateAccount(): void {
    this.performingAction = true;

    this.$accountClient.addUpdateReturnOnlyID(this.selectedAccount).then((recID: number) => {
      this.performingAction = false;
      this.selectedAccount.id = recID;
      if (this.selectedAccount.id === undefined) {
        this.accounts.push(this.selectedAccount);
        //     this.$toaster.pop('success', "Created new account!", this.selectedAccount.accountName + " has been added to the system.");
      } else {
        //   this.$toaster.pop('success', "Updated account!", this.selectedAccount.accountName + " has been updated.");
      }
    });
  }
}
